import { Decimal } from 'decimal.js'

import type { TSimulacaoCalculoValoresTotais } from '@/domain/simulador/factories/types/simulacao-calculo'
import type { IParcela } from '@/domain/simulador/gerenciador-pos-conclusao.interface'
import { ProcessadorValoresDecimal, type IProcessadorValoresDecimal } from '@/utils/calculadora-valores-totais'

export class CalculadoraValoresTotaisSacocH {
  constructor(
    private readonly grupos: TSimulacaoCalculoValoresTotais,
    private readonly processador: IProcessadorValoresDecimal = new ProcessadorValoresDecimal(),
  ) {}

  get totalDeEntradas() {
    return this.processador.calcularTotalEntradas(this.grupos?.entradas)
  }

  get totalDeMensais() {
    return this.processador.calcularTotalMensais(this.grupos?.mensais)
  }

  get totalDeIntermediarias() {
    return this.processador.calcularTotalIntermediarias(this.grupos?.intermediarias)
  }

  get valorTotalSimulacao() {
    return new Decimal(this.totalDeEntradas).plus(this.totalDeMensais).plus(this.totalDeIntermediarias).toNumber()
  }

  calcularTotalAteDataDeEntrega(parcelas: IParcela[], dataPrevisaoDeEntregaDoBloco?: string): number {
    if (!dataPrevisaoDeEntregaDoBloco) {
      return parcelas.reduce((total, parcela) => total.plus(parcela.valor), new Decimal(0)).toNumber()
    }

    const dataEntrega = new Date(dataPrevisaoDeEntregaDoBloco)

    return parcelas
      .reduce((total, parcela) => {
        const dataParcela = new Date(parcela.data)
        return dataParcela <= dataEntrega ? total.plus(parcela.valor) : total
      }, new Decimal(0))
      .toNumber()
  }

  percentualPoupanca(parcelas: IParcela[], dataPrevisaoDeEntregaDoBloco?: string): number {
    const totalParcelasAteDataEntrega = this.calcularTotalAteDataDeEntrega(parcelas, dataPrevisaoDeEntregaDoBloco)
    if (this.valorTotalSimulacao <= 0) return 0
    return (totalParcelasAteDataEntrega / this.valorTotalSimulacao) * 100
  }
}
